import React, { Fragment, useState, useEffect, useRef, useCallback } from 'react';
import { chunk } from 'lodash';
import { FormattedMessage } from 'react-intl';
import FacetItemWrapper from '../facetItemWrapper';
import { WOMEN_LEISUREWEAR_IDS } from '../../facetsListConstants';
import { getFacetsToRender } from '../../facetListUtils';
import mediaQueries from '../../../../../utils/mediaQueries';

const isLargeUp = mediaQueries.is_large_up();

const {
  advancedCommerce: { enabled: isListingPage },
} = window.inlineGlobalConfig;

const SizeFacetValueSection = props => {
  const { sectionTitle, facet, chunkSize } = props;
  const [isActive, setIsActive] = useState(true);
  const ref = useRef(null);
  const facetsToRender = getFacetsToRender(sectionTitle, facet);
  const isLeisurewear = WOMEN_LEISUREWEAR_IDS.includes(facetsToRender[0].id);

  const onTitleClickHandler = () => setIsActive(prevState => !prevState);

  const setAccordionContentMaxHeight = useCallback(() => {
    if (isActive && ref.current) {
      const { parentElement: sectionElement } = ref.current;
      const computedStyle = getComputedStyle(sectionElement);
      const accordionContent = sectionElement.parentElement;
      accordionContent.style.maxHeight = `${
        sectionElement.offsetHeight + parseFloat(computedStyle.marginTop) + parseFloat(computedStyle.marginBottom)
      }px`;
    }
  }, [isActive]);

  useEffect(() => {
    setAccordionContentMaxHeight();
  }, [isActive, setAccordionContentMaxHeight]);

  return (
    <>
      {sectionTitle && (
        <button
          type="button"
          aria-expanded={isActive}
          onClick={onTitleClickHandler}
          className={`facet-header facet__item facet__item--title ${isActive ? 'active' : ''}`}
        >
          {isListingPage ? <FormattedMessage id={sectionTitle} description="facet title size" /> : sectionTitle}
          {isLargeUp && (
            <span>
              <FormattedMessage id="search.result.facet.size.indicator" description="Size indicator per locale" />
            </span>
          )}
        </button>
      )}
      {isActive && (
        <div className="facet__item-subsection" ref={ref}>
          {/* TODO check if this is needed anymore for tablet with leisureWear */}
          {/* {isLeisurewear && ( */}
          {/*  <span className="facet__item-subsection-title"> */}
          {/*    <FormattedMessage id="search.result.facet.size.indicator" description="Locale size indicater" />{' '} */}
          {/*  </span> */}
          {/* )} */}
          <ul className={`facet facet__size ${isLeisurewear ? 'facet__size--leisurewear' : ''}`}>
            {chunk(facetsToRender, chunkSize).map(facetsChunk => (
              <Fragment key={`section-${facet.id}-${facetsChunk[0].id}`}>
                {facetsChunk.map(facetItem => (
                  <FacetItemWrapper {...props} key={facetItem.id} facetItem={facetItem}>
                    <span className="facet__checkbox size-group" style={{ marginRight: '10px' }} />
                  </FacetItemWrapper>
                ))}
              </Fragment>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default SizeFacetValueSection;
